import { useOnboarding } from '../context/OnboardingContext'
import { WizardChrome } from './WizardChrome'
import { EntityWorkflow } from './entity/EntityWorkflow'
import { StepWelcome } from './steps/StepWelcome'
import { StepChecklist } from './steps/StepChecklist'
import { StepImportant } from './steps/StepImportant'
import { StepEntitySetup } from './steps/StepEntitySetup'
import { StepEntityDashboard } from './steps/StepEntityDashboard'
import { StepContacts } from './steps/StepContacts'
import { StepAttestation } from './steps/StepAttestation'
import { StepOtr } from './steps/StepOtr'
import { StepReview } from './steps/StepReview'
import { StepComplete } from './steps/StepComplete'

export function WizardView() {
  const { location } = useOnboarding()

  const body = (() => {
    if (location.kind === 'entity') return <EntityWorkflow />
    switch (location.step) {
      case 'welcome':
        return <StepWelcome />
      case 'checklist':
        return <StepChecklist />
      case 'important':
        return <StepImportant />
      case 'entitySetup':
        return <StepEntitySetup />
      case 'entityDashboard':
        return <StepEntityDashboard />
      case 'contacts':
        return <StepContacts />
      case 'attestation':
        return <StepAttestation />
      case 'otr':
        return <StepOtr />
      case 'review':
        return <StepReview />
      case 'complete':
        return <StepComplete />
    }
  })()

  return <WizardChrome>{body}</WizardChrome>
}
